'use client';

import { useClientTranslation } from '@bts-web/utils-lokalise';
import React from 'react';
import { getOrdersListTranslations } from '../utils/getOrdersListTranslations';
import { TFunction } from 'i18next';
import { css } from '@bts-web/utils-style-engine';
import { RegularStopOrder } from '../../common/svgIcons';

function OrdersListEmptyScreen() {
  const { t } = useClientTranslation();

  const translations = getOrdersListTranslations(t as TFunction);

  return (
    <>
      <div
        className={css({
          display: 'flex',
          paddingY: 'medium',
          flexDirection: 'column',
          alignItems: 'center',
          alignSelf: 'stretch',
          flex: 1,
          justifyContent: 'center',
        })}
      >
        <div
          className={css({
            backgroundColor: 'neutrals.fill_quinary',
            color: 'neutrals.fill_primary',
            display: 'flex',
            padding: 'medium',
            borderRadius: 'medium',
          })}
        >
          <RegularStopOrder size={32} />
        </div>
        <p
          className={css({
            color: 'neutrals.text_primary',
            textAlign: 'center',
            fontSize: 'headline.small_medium',
            fontWeight: 'display.extra_large_medium',
            letterSpacing: 'small',
            lineHeight: 'small',
          })}
        >
          {translations.stopOrderTargetTitle}
        </p>
        <p
          className={css({
            color: 'neutrals.text_secondary',
            textAlign: 'center',
            fontSize: 'body.medium',
            fontWeight: 'display.medium',
            letterSpacing: 'small',
            lineHeight: 'headline.medium_medium',
          })}
        >
          {translations.stopOrderTargetSubtitle}
        </p>
      </div>
    </>
  );
}

export default OrdersListEmptyScreen;
